<template>
  <div class="page-content">
    <breadcrumb-index :items="breadcrumbs">
      <template #actions>
        <router-link :to="`/app/subjects/${subjectId}/topics`" class="btn btn-outline-secondary btn-sm">
          <vue-feather type="arrow-left" size="14" class="me-1" />
          Back
        </router-link>
      </template>
    </breadcrumb-index>

    <div class="card">
      <div class="card-header">
        <h6 class="card-title mb-0">Add Topic</h6>
        <small class="text-muted" v-if="subject">for {{ subject.name }}</small>
      </div>
      <div class="card-body">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-lg-8">
              <div class="row">
                <div class="col-md-8 mb-3">
                  <label class="form-label">Topic Name <span class="text-danger">*</span></label>
                  <input v-model="form.name" type="text" class="form-control" required placeholder="e.g., Ancient India" />
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">Display Order</label>
                  <input v-model.number="form.order" type="number" class="form-control" min="1" />
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Description</label>
                <textarea v-model="form.description" class="form-control" rows="3" placeholder="Brief description of the topic"></textarea>
              </div>

              <div class="row">
                <div class="col-md-4 mb-3">
                  <label class="form-label">Status</label>
                  <select v-model="form.status" class="form-select">
                    <option value="draft">Draft</option>
                    <option value="active">Active</option>
                  </select>
                </div>
              </div>

              <div v-if="error" class="alert alert-danger">{{ error }}</div>

              <div class="d-flex gap-2 pt-2">
                <button type="submit" class="btn btn-primary" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                  Create Topic
                </button>
                <router-link :to="`/app/subjects/${subjectId}/topics`" class="btn btn-outline-secondary">Cancel</router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '@/services/api'
import { useAlert } from '@/plugins/sweetalert'

export default {
  name: 'AddTopic',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const alert = useAlert()
    const subjectId = route.params.subjectId

    const subject = ref(null)
    const form = ref({
      name: '',
      description: '',
      order: 1,
      status: 'draft'
    })
    const loading = ref(false)
    const error = ref('')

    const breadcrumbs = computed(() => [
      { title: 'Dashboard', url: '/app/dashboard' },
      { title: 'Exams', url: '/app/exams/list' },
      { title: subject.value?.name || 'Subject', url: `/app/subjects/${subjectId}/topics` },
      { title: 'Add Topic', active: true }
    ])

    const fetchSubject = async () => {
      try {
        const response = await api.get(`/v1/admin/subjects/${subjectId}`)
        subject.value = response.data.subject
      } catch (err) {
        console.error('Failed to fetch subject:', err)
      }
    }

    const handleSubmit = async () => {
      loading.value = true
      error.value = ''

      try {
        await api.post(`/v1/admin/subjects/${subjectId}/topics`, form.value)
        alert.success('Success', 'Topic created successfully')
        router.push(`/app/subjects/${subjectId}/topics`)
      } catch (err) {
        error.value = err.response?.data?.message || 'Failed to create topic'
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchSubject)

    return { subjectId, subject, form, loading, error, breadcrumbs, handleSubmit }
  }
}
</script>
